<script setup lang="ts">
  import {
    formSectionContainerClass,
    formSectionDescriptionClass,
    formSectionGridClass,
    formSectionTitleClass,
  } from './FormSection.css';

  defineProps<{
    columns: number;
    title?: string;
    description?: string;
  }>();
</script>

<template>
  <div :class="formSectionContainerClass">
    <slot name="title">
      <h2 v-if="title" :class="formSectionTitleClass">{{ title }}</h2>
    </slot>
    <slot name="description">
      <p v-if="description" :class="formSectionDescriptionClass">
        {{ description }}
      </p>
    </slot>
    <div
      :class="formSectionGridClass"
      :style="{
        gridTemplateColumns: `repeat(${columns || 1}, minmax(0, 1fr))`,
      }"
    >
      <slot />
    </div>
  </div>
</template>
